import React, { useState, useEffect } from 'react';

const ProdutosAgricultorPage = ({ onNavigate }) => {
  const [produtos, setProdutos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const [novoProduto, setNovoProduto] = useState({ 
    nome: '', 
    quantidade: '', 
    unidade: 'kg',
    preco: ''
  });

  const agricultorId = localStorage.getItem('agricultorId');

  useEffect(() => {
    carregarProdutos();
  }, []);

  const carregarProdutos = async () => {
    if (!agricultorId) {
      setError('ID do agricultor não encontrado');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`http://localhost:3000/produtos?agricultorId=${agricultorId}`);
      
      if (response.ok) {
        const data = await response.json();
        setProdutos(data);
        setError('');
      } else {
        const errorText = await response.text();
        console.error('Erro ao carregar produtos:', errorText);
        setError('Erro ao carregar produtos');
      }
    } catch (error) {
      console.error('Erro de conexão:', error);
      setError('Erro de conexão com o servidor');
    } finally {
      setLoading(false);
    }
  };

  const handleAddProduto = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    const quantidade = parseFloat(novoProduto.quantidade);
    const preco = parseFloat(novoProduto.preco);

    if (isNaN(quantidade) || quantidade <= 0) {
      setError('Quantidade deve ser um número positivo');
      return;
    }

    if (isNaN(preco) || preco < 0) {
      setError('Preço deve ser um número válido');
      return;
    }

    if (!novoProduto.nome.trim()) {
      setError('Nome do produto é obrigatório');
      return;
    }

    try {
      const response = await fetch('http://localhost:3000/produtos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nome: novoProduto.nome,
          quantidade: quantidade,
          unidade: novoProduto.unidade,
          preco: preco,
          proprietarioId: agricultorId
        }),
      });

      if (response.ok) {
        setSuccess('Produto adicionado com sucesso!');
        setNovoProduto({ nome: '', quantidade: '', unidade: 'kg', preco: '' });
        carregarProdutos();
        
        setTimeout(() => setSuccess(''), 3000);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Erro ao adicionar produto');
      }
    } catch (error) {
      console.error('Erro ao adicionar produto:', error);
      setError('Erro de conexão com o servidor');
    }
  };

  const handleDeleteProduto = async (id) => {
    if (!window.confirm('Tem certeza que deseja remover este produto?')) {
      return;
    }

    try {
      const response = await fetch(`http://localhost:3000/produtos/${id}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setSuccess('Produto removido com sucesso!');
        carregarProdutos();
        setTimeout(() => setSuccess(''), 3000);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Erro ao remover produto');
      }
    } catch (error) {
      console.error('Erro ao remover produto:', error);
      setError('Erro de conexão com o servidor');
    }
  };

  if (loading) {
    return (
      <div className="produtos-container">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Carregando produtos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="produtos-container">
      <div className="produtos-content">
        {error && (
          <div className="alert alert-error">
            <span className="alert-icon">⚠️</span>
            <span className="alert-text">{error}</span>
          </div>
        )}
        {success && (
          <div className="alert alert-success">
            <span className="alert-icon">✓</span>
            <span className="alert-text">{success}</span>
          </div>
        )}

        {/* Formulário de adicionar produto */}
        <div className="add-produto-section">
          <h2 className="section-title">
            <span className="title-icon">➕</span>
            Adicionar Novo Produto
          </h2>
          <form onSubmit={handleAddProduto} className="add-produto-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nome">Nome do Produto</label>
                <input
                  type="text"
                  id="nome"
                  value={novoProduto.nome}
                  onChange={(e) => setNovoProduto({ ...novoProduto, nome: e.target.value })}
                  placeholder="Ex: Tomate, Alface, Cenoura"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="quantidade">Quantidade</label>
                <input
                  type="number"
                  id="quantidade"
                  value={novoProduto.quantidade}
                  onChange={(e) => setNovoProduto({ ...novoProduto, quantidade: e.target.value })}
                  placeholder="0"
                  step="0.01"
                  min="0"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="unidade">Unidade</label>
                <select
                  id="unidade"
                  value={novoProduto.unidade}
                  onChange={(e) => setNovoProduto({ ...novoProduto, unidade: e.target.value })}
                  required
                >
                  <option value="kg">Quilograma (kg)</option>
                  <option value="g">Grama (g)</option>
                  <option value="un">Unidade (un)</option>
                  <option value="caixa">Caixa</option>
                  <option value="L">Litro (L)</option>
                  <option value="mL">Mililitro (mL)</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="preco">Preço (R$)</label>
                <input
                  type="number"
                  id="preco"
                  value={novoProduto.preco}
                  onChange={(e) => setNovoProduto({ ...novoProduto, preco: e.target.value })}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn-add-produto">
              <span className="btn-icon">➕</span>
              Adicionar Produto
            </button>
          </form>
        </div>

        {/* Lista de produtos */}
        <div className="produtos-list-section">
          <h2 className="section-title">
            <span className="title-icon">📦</span>
            Meus Produtos ({produtos.length})
          </h2>

          {produtos.length === 0 ? (
            <div className="empty-state">
              <span className="empty-icon">📦</span>
              <h3>Nenhum produto cadastrado</h3>
              <p>Adicione produtos usando o formulário acima para que os restaurantes possam encontrá-los.</p>
            </div>
          ) : (
            <div className="produtos-grid">
              {produtos.map((produto) => (
                <div key={produto.id} className="produto-card">
                  <div className="produto-header">
                    <h3 className="produto-nome">{produto.nome}</h3>
                    <span className="produto-preco">R$ {produto.preco.toFixed(2)}</span>
                  </div>
                  <div className="produto-details">
                    <div className="produto-detail-item">
                      <span className="detail-label">Quantidade</span>
                      <span className="detail-value">{produto.quantidade} {produto.unidade}</span>
                    </div>
                    <div className="produto-detail-item">
                      <span className="detail-label">Preço por {produto.unidade}</span>
                      <span className="detail-value">R$ {produto.preco.toFixed(2)}</span>
                    </div>
                  </div>
                  <button 
                    className="btn-delete-produto"
                    onClick={() => handleDeleteProduto(produto.id)}
                  >
                    <span className="btn-icon">🗑️</span>
                    Remover
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProdutosAgricultorPage;
